import { darken } from 'polished';
import styled from 'styled-components';

interface ContainerProps {
  haveImage: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;
  position: relative;

  label {
    border-radius: 10px;
    width: 10rem;
    height: 10rem;
    border: 2px dashed ${darken(0.25, '#ccc')};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    svg {
      font-size: 2.5rem;
      color: ${darken(0.25, '#ccc')};
      position: absolute;
      display: ${({ haveImage }) => (haveImage ? 'none' : 'block')};
    }

    &:hover {
      cursor: pointer;

      svg {
        display: block;
        color: ${({ haveImage }) => (haveImage ? '#fff' : darken(0.4, '#ccc'))};
      }
    }

    input {
      display: none;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 10px;
    }
  }
`;
